import React from "react";
import PlaygroundContent from "./../components/playground/PlaygroundContent";

function PlaygroundPage() {
  return (
    <div>
      <PlaygroundContent /> 
    </div>
  );
}

export default PlaygroundPage;
